import { api } from '../../../../components/common';
import { ImportCatalogResponse, ImportResult } from '../types';

export const importsApi = {
  getCatalog: (): Promise<ImportCatalogResponse> =>
    api.get('/imports/catalog').then((res) => res.data),

  importCrsData: (files: File[]): Promise<ImportResult> => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    return api.post('/imports/crs-data', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((res) => res.data);
  },

  importCrsAbsenteeMerge: (absentee: File, property: File): Promise<ImportResult> => {
    const formData = new FormData();
    formData.append('absentee', absentee);
    formData.append('property', property);
    return api.post('/imports/crs-data-absentee-merge', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((res) => res.data);
  }
};
